import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  position: relative;
  margin-right: 20px;
  grid-gap: 5px;
  
  @media (max-width: 768px) {
    margin-left: 20px;
  }
`;

const LeftPhotos = styled.div`
  grid-column: 1;
  display: grid;
  grid-template-rows: 1fr 3fr 1fr;
  grid-gap: 5px;
  max-height: 680px;
  overflow: hidden;
`;

const RightPhotosContainer = styled.div`
  grid-column: 2/3;
  display: grid;
  grid-template-rows: 1fr 2fr;
  grid-gap: 5px;
`;

const RightTopPhotos = styled.div`
  grid-row: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  max-height: 225px;
  overflow: hidden;
`;

const RightBottomContainer = styled.div`
  grid-row: 2/3;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
`;

const RightBottomLeftPhotos = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-gap: 5px;
`;

const RightBottomRightPhotos = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 5px;
  max-height: 450px;
  overflow: hidden;
`;

const ItemsGrid = ({items}) => {
  return (
    <Container>
      <LeftPhotos>{items.slice(0,3)}</LeftPhotos>
      <RightPhotosContainer>
        <RightTopPhotos>{items.slice(3,5)}</RightTopPhotos>
        <RightBottomContainer>
          <RightBottomLeftPhotos>{items.slice(5,6)}</RightBottomLeftPhotos>
          <RightBottomRightPhotos>{items.slice(6,8)}</RightBottomRightPhotos>
        </RightBottomContainer>
      </RightPhotosContainer>
    </Container>
  )
};

export default ItemsGrid;